import { IButtonStyles, IButtonProps, HighContrastSelector } from '@fluentui/react';

export const TeamsDefaultButtonStyles = (props: IButtonProps): Partial<IButtonStyles> => {
  const { theme } = props;

  return {
    root: {
      border: `1px solid ${props.theme?.semanticColors.buttonBorder}`,
      borderRadius: 4,
      [HighContrastSelector]: {
        border: `1px solid ${theme?.semanticColors.buttonBorder}`,
      },
    },
  };
};
